import { useMemo } from 'react';

import { bannerDesigns } from 'components/TemplatesStudio/DesignsMetadata/banners.metadata';

import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const BannerDesignsSecondarySidebar: React.FC = () => {
  const designs = useMemo(() => {
    return Object.values(bannerDesigns);
  }, []);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="banner.selectedDesignId"
        />
      ))}
    </>
  );
};
